module.exports = __webpack_public_path__ + "static/img/total_user.6b38b2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/total_user.png
// module id = i87G
// module chunks = 0